import { useRootStore } from './RootStore';

export const useGolfShopStore = () => useRootStore().golfShopStore;
export const useNotificationStore = () => useRootStore().notificationStore;
export const useAlertStore = () => useRootStore().alertStore;
